import { useLazyQuery } from '@apollo/client';
import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import LoaderComponent from '../../../components/LoaderComponent';
import { TOY } from '../graphql/Queries';
import ToyDetails from './ToyDetails';

const ToyDetailsContent = ({ toyId }) => {
  const [form] = Form.useForm();
  const [toyDetail, setToyDetail] = useState({});
  const [isToyLoading, setIsToyLoading] = useState(true);
  const [toyImages, setToyImages] = useState([]);
  const [featuredImage, setFeaturedImage] = useState([]);
  const [toyVideo, setToyVideo] = useState([]);

  const [toy] = useLazyQuery(TOY, {
    onCompleted: (response) => {
      const toyImagesArray = response?.toy?.images;
      const featuredImageObj = toyImagesArray?.shift();
      setToyImages(toyImagesArray);
      setFeaturedImage(featuredImageObj ? [featuredImageObj] : []);
      setToyVideo(
        response?.toy?.videoUrl ? { url: response?.toy?.videoUrl } : [],
      );
      setToyDetail({
        ...response?.toy,
        featuredImages: featuredImageObj ? [featuredImageObj] : [],
      });
      setIsToyLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setIsToyLoading(false);
    },
  });

  useEffect(() => {
    if (!toyId) return;
    setIsToyLoading(true);
    setToyDetail({});
    toy({
      variables: {
        where: {
          id: toyId,
        },
      },
    });
  }, [toyId]);

  if (isToyLoading) {
    return (
      <LoaderComponent size="large" setHeight="60" spinning={isToyLoading} />
    );
  }

  return (
    <div className="toy-form">
      <ToyDetails
        form={form}
        isView
        toyImages={toyImages}
        toyDetail={toyDetail}
        featuredImage={featuredImage}
        toyVideo={toyVideo}
      />
    </div>
  );
};

export default ToyDetailsContent;
